// @flow
import React, { useContext } from 'react';

import { mapCategories } from 'Client/cms/toolkit/product-utils/productFeatures.utils';
import { productActivityDetailQuery } from 'Client/cms/toolkit/product-utils/productFeatures.queries';
import { useRouter } from 'Client/router/useRouter';
import ReactAppContext from 'Context/ReactAppContext';
import { addTranslationKeys } from 'Src/i18n';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { WIDGET_PRODUCT_ACTIVITIES_FETCH_SERVICES } from 'Utils/request/requestDictionary';
import { TRACKING_PREFIX_MAPPING } from 'Utils/tracking/resort';

import { ProductFeatures } from 'Components/widgets//product-features/ProductFeatures.jsx';
import { ProductFeatureDetail } from 'Components/widgets/product-feature-detail/ProductFeatureDetail.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';

export const ProductActivitiesLine = (props: ProductActivitiesLineProps) => {
  const {
    config: {
      common: { loadLess, scrollBackward, scrollForward, viewMore },
    },
    id,
    resort,
  } = props;
  const { location } = useRouter<UrlParams, QueryParams>();
  const appContext = useContext(ReactAppContext);

  if (!resort) {
    return null;
  }

  const fetchActivityServices = ({ productId, activityId }) => {
    const query = productActivityDetailQuery(productId, activityId, {
      lineProps: props,
      urlParams: location.urlParams,
    });

    return graphQLClient
      .runQuery(query, appContext, {
        requestName: WIDGET_PRODUCT_ACTIVITIES_FETCH_SERVICES,
      })
      .then(data => {
        addTranslationKeys(data.config);
        return {
          productActivities: {
            ...data.productActivities,
            includedServices: data.includedServices,
            onDemandServices: data.onDemandServices,
          },
        };
      });
  };

  const introduction = {
    seeLessLabel: loadLess,
    seeMoreLabel: viewMore,
    text: (resort.activitiesIntroduction && resort.activitiesIntroduction.description) || '',
    title: (resort.activitiesIntroduction && resort.activitiesIntroduction.shortDescription) || '',
  };

  const productActivitiesCategories =
    resort.categories && resort.categories.leisure
      ? resort.categories.leisure.filter(({ activities }) => activities && activities.length !== 0)
      : [];

  const productCategories = mapCategories({
    fetchActivityServices,
    labelGAPrefix: TRACKING_PREFIX_MAPPING.ACTIVITIES,
    productActivitiesCategories,
    productFeaturesLineData: props,
  });

  return (
    <SiteContainer className="Line" id={id}>
      <ProductFeatures
        categories={productCategories}
        introduction={introduction}
        labelGAPrefix={TRACKING_PREFIX_MAPPING.ACTIVITIES}
        queryLayer="productActivitiesLayer"
        renderDetail={data => <ProductFeatureDetail {...data} />}
        scrollBackwardLabel={scrollBackward}
        scrollForwardLabel={scrollForward}
      />
    </SiteContainer>
  );
};
